module.exports = __webpack_public_path__ + "img/logo.baaa989b.jpg";